const routers = [
  {
    // 入库管理
    path: '/instore/list',
    name: 'instore',
    component: () => import('@/views/modules/store/instore/List.vue')
  },
  {
    // 出库管理
    path: '/outstore/list',
    name: 'outstore',
    component: () => import('@/views/modules/store/outstore/List.vue')
  },
  {
    // 半成品入库
    path: '/halfproductinstore/list',
    name: 'halfproductinstore',
    component: () => import('@/views/modules/store/halfproductinstore/List.vue')
  },
  {
    // 半成品出库
    path: '/halfproductoutstore/list',
    name: 'halfproductoutstore',
    component: () => import('@/views/modules/store/halfproductoutstore/List.vue')
  },
  {
    // 库存调整
    path: '/storechange/list',
    name: 'storechange',
    component: () => import('@/views/modules/store/storechange/List.vue')
  },
  {
    // 社内入库管理
    path: '/inside/list',
    name: 'inside',
    component: () => import('@/views/modules/store/inside/List.vue')
  },
  {
    // 社内出库管理
    path: '/outside/list',
    name: 'outside',
    component: () => import('@/views/modules/store/outside/List.vue')
  },
  {
    // 不良品出库管理
    path: '/outreject/list',
    name: 'outreject',
    component: () => import('@/views/modules/store/outreject/List.vue')
  },
  {
    // 不良品入库管理
    path: '/inreject/list',
    name: 'inreject',
    component: () => import('@/views/modules/store/inreject/List.vue')
  },
  {
    // 台纸管理中报表（echart）列表
    path: '/report/list',
    name: 'report',
    component: () => import('@/views/modules/store/report/List.vue')
  }
]
export default routers
